import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MsSentimentType } from '@sb-tools/typescript/enums/ms-sentiment-type.enum';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ConfidencePercentPipe } from '../../../shared/pipes/confidence-percent.pipe';

@Component({
    selector: 'app-ms-sentiment',
    templateUrl: './ms-sentiment.component.html',
    styleUrls: ['./ms-sentiment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgSwitch, NgSwitchCase, TranslateModule, TooltipModule, ConfidencePercentPipe],
})
export class MsSentimentComponent {
    @Input() sentimentScore: number;
    @Input() sentimentValue: MsSentimentType;

    msSentimentTypeEnum = MsSentimentType;
}
